import { render, staticRenderFns } from "./navigation-left.component.vue?vue&type=template&id=a6723c80&scoped=true"
import script from "./navigation-left.component.vue?vue&type=script&lang=js"
export * from "./navigation-left.component.vue?vue&type=script&lang=js"
import style0 from "./navigation-left.component.vue?vue&type=style&index=0&id=a6723c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6723c80",
  null
  
)

export default component.exports